import React, { Fragment } from "react";
import { RouteData, SiteData } from "react-static";
import styled from "@emotion/styled";

import Markdown from "../components/markdown";
import Section from "../components/section/section";
import { Description } from "../components/hero-quote";
import Down from "../components/next-section-arrow";
import Seo from "../components/seo";

const Wrapper = styled.div`
  min-height: 408px;
  display: inline-block;
  position: relative;
  margin: 2rem;
  &:hover {
    & > div {
      opacity: 1;
    }
  }
`;

const ImageStyle = styled.img`
  height: auto;
  max-height: 371px;
  width: 280px;
  vertical-align: center;
  display: block;
  position: relative;
  ${"" /* border: solid 1px black; */}
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
`;
const TeamImage = ({ imgSrc }) => (
  <ImageStyle src={`${imgSrc || "/media/ICON.png"}`} />
);

const DescriptionStyle = styled.div`
  width: 100%;
  height: 371px;
  overflow-y: scroll;
  display: block;
  position: absolute;
  background-color: #ffffff;
  ${"" /* border: 1px solid #323232; */}
  color: black;
  top: -1.5rem;
  left: 1rem;
  transition: all 0.5s ease;
  font-family: "Lyon", serif;
  font-size: 11pt;
  line-height: 1.5;
  & > div {
    padding: 1rem;
  }
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
`;

const DStyle = styled.div`
  width: 100%;
  height: 371px;
  overflow-y: scroll;
  display: block;
  position: absolute;
  background-color: #ffffff;
  ${"" /* border: 1px solid #323232; */}
  color: black;
  top: -1.5rem;
  left: 1rem;
  transition: all 0.5s ease;
  opacity: 0;
  font-family: "Lyon", serif;
  font-size: 11pt;
  line-height: 1.5;
  & > div {
    padding: 1rem;
  }
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
`;

const Name = styled.figcaption`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
`;

const TeamPhoto = ({ imgSrc, description, name }) => (
  <Wrapper>
    <DescriptionStyle>
      <Markdown source={description} />
    </DescriptionStyle>
    <TeamImage imgSrc={imgSrc} />
    <Name>{name}</Name>
    <DStyle>
      <Markdown source={description} />
    </DStyle>
  </Wrapper>
);

function Team({ members, copy, meta, siteData }) {
  const founders = members
    .filter(m => m.data.role === "founder")
    .sort((a, b) => a.data.order - b.data.order);
  const regulars = members
    .filter(m => m.data.role === "member")
    .sort((a, b) => a.data.order - b.data.order);
  return (
    <Fragment>
      <Seo
        url="https://inotherwords.id/team"
        siteTitle={siteData.data.title}
        pageTitle={meta.title}
        description={meta.description}
        image={meta.image}
        siteFBAppID={siteData.data.fbappid}
        userTwitter={siteData.data.twitter}
      />
      <Section title={copy.data.title} renderButton={() => <Down />}>
        <Description>{copy.content}</Description>
      </Section>
      <Section
        innerFull
        innerDirection={"row"}
        innerWrap
        center
        title={"Founders"}
        renderButton={() => <Down />}
      >
        {founders.map((person, j) => (
          <TeamPhoto
            key={`Founder ${j}`}
            imgSrc={person.data.image}
            description={person.content}
            name={person.data.title}
          />
        ))}
      </Section>

      <Section
        innerFull
        innerDirection={"row"}
        innerWrap
        center
        title={"Members"}
      >
        {regulars.map((s, i) => (
          <TeamPhoto
            key={`Member ${i}`}
            imgSrc={s.data.image}
            description={s.content}
            name={s.data.title}
          />
        ))}
      </Section>
    </Fragment>
  );
}

export default () => (
  <SiteData>
    {siteData => (
      <RouteData>
        {routeData => <Team {...routeData} siteData={siteData} />}
      </RouteData>
    )}
  </SiteData>
);
